import { updateObject } from "../_utils";
import profileConstants from "../_constants/profileConstants";
import userConstants from "../_constants/userConstants";

const initialState = {
  info: {},
  actions: {
    like: false,
    interest: false,
    shortlist: false,
    save: false,
    favorite: false,
    pendingConnect: false,
    requestedToConnect: false,
    connected: false
  },
  preference: {},
  privacy: {},
  topImages: [],
  images: [],
  mobile: {}
};

const viewMemberProfile = (state, action) => {
  return updateObject(state, { info: action.payload });
};
const clearMemberProfile = (state, action) => {
  return updateObject(state, { info: {} });
};
const changeProfileLikedStatus = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { like: action.payload })
  });
};
const changeProfileInterestStatus = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { interest: action.payload })
  });
};
const changeProfileShortlistedStatus = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { shortlist: action.payload })
  });
};
const changeProfileSavedStatus = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { save: action.payload })
  });
};
const changeProfileAddedToFavorite = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { favorite: action.payload })
  });
};
const getMembersPartnerPreference = (state, action) => {
  return updateObject(state, {
    preference: action.payload
  });
};
const clearMembersPartnerPreference = (state, action) => {
  return updateObject(state, {
    preference: {}
  });
};
const changeRequestPendingForConnect = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { pendingConnect: action.payload })
  });
};
const changeRequestedToConnect = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { requestedToConnect: action.payload })
  });
};
const changeConnected = (state, action) => {
  return updateObject(state, {
    actions: updateObject(state.actions, { connected: action.payload })
  });
};
const getMemberPrivacy = (state, action) => {
  return updateObject(state, {
    privacy: action.payload
  });
};
const clearMemberPrivacy = (state, action) => {
  return updateObject(state, {
    privacy: {}
  });
};
const getMemberTopImages = (state, action) => {
  return updateObject(state, {
    topImages: action.payload
  });
};
const clearMemberTopImages = (state, action) => {
  return updateObject(state, {
    topImages: []
  });
};

const getMemberAllImages = (state, action) => {
  return updateObject(state, {
    images: action.payload
  });
};
const clearMemberAllImages = (state, action) => {
  return updateObject(state, {
    images: []
  });
};

const getMemberMobileNumber = (state, action) => {
  return updateObject(state, {
    mobile: action.payload
  });
};
const clearMemberMobileNumber = (state, action) => {
  return updateObject(state, {
    mobile: {}
  });
};
/* ---------------------------------------------------
      SIGN OUT
  ----------------------------------------------------- */
const signOut = (state, action) => {
  return initialState;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case profileConstants.VIEW_MEMBER_PROFILE:
      return viewMemberProfile(state, action);
    case profileConstants.CHANGE_PROFILE_LIKED_STATUS:
      return changeProfileLikedStatus(state, action);
    case profileConstants.CHANGE_PROFILE_INTEREST_STATUS:
      return changeProfileInterestStatus(state, action);
    case profileConstants.CHANGE_PROFILE_SHORTLISTED_STATUS:
      return changeProfileShortlistedStatus(state, action);
    case profileConstants.CHANGE_PROFILE_SAVED_STATUS:
      return changeProfileSavedStatus(state, action);
    case profileConstants.CHANGE_PROFILE_ADDED_TO_FAVORITE:
      return changeProfileAddedToFavorite(state, action);
    case profileConstants.GET_MEMBERS_PARTNER_PREFERENCE:
      return getMembersPartnerPreference(state, action);
    case profileConstants.CLEAR_MEMBERS_PARTNER_PREFERENCE:
      return clearMembersPartnerPreference(state, action);
    case profileConstants.CHANGE_REQUEST_PENDING_FOR_CONNECT:
      return changeRequestPendingForConnect(state, action);
    case profileConstants.CHANGE_REQUESTED_TO_CONNECT:
      return changeRequestedToConnect(state, action);
    case profileConstants.CHANGE_CONNECTED:
      return changeConnected(state, action);
    case profileConstants.GET_MEMBER_PRIVACY:
      return getMemberPrivacy(state, action);
    case profileConstants.CLEAR_MEMBER_PRIVACY:
      return clearMemberPrivacy(state, action);
    case profileConstants.GET_MEMBER_TOP_IMAGES:
      return getMemberTopImages(state, action);
    case profileConstants.CLEAR_MEMBER_TOP_IMAGES:
      return clearMemberTopImages(state, action);
    case profileConstants.CLEAR_MEMBER_PROFILE:
      return clearMemberProfile(state, action);
    case profileConstants.GET_MEMBER_ALL_IMAGES:
      return getMemberAllImages(state, action);
    case profileConstants.CLEAR_MEMBER_ALL_IMAGES:
      return clearMemberAllImages(state, action);
    case profileConstants.GET_MEMBER_MOBILE_NUMBER:
      return getMemberMobileNumber(state, action);
    case profileConstants.CLEAR_MEMBER_MOBILE_NUMBER:
      return clearMemberMobileNumber(state, action);
    case userConstants.SIGN_OUT:
      return signOut(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/_reducers/profileReducer.js